import { render, staticRenderFns } from "./ActivateDeactivateInternetBanking.vue?vue&type=template&id=2758c1e1&"
import script from "./ActivateDeactivateInternetBanking.vue?vue&type=script&lang=js&"
export * from "./ActivateDeactivateInternetBanking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports